import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import "./product_entry.css";

import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { styled } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Delete";
import { Image, VideoCall } from "@mui/icons-material";
import {
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Paper,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { addStepFour } from "../../redux/features/product.features";

const ProductStepOne = () => {
  const Input = styled("input")({
    display: "none",
  });
  const dispatch = useDispatch();
  let productState = useSelector((state) => {
    return state.productReducer;
  });
  let { stepFour } = productState;
  const [imgList, setImageList] = useState(stepFour.images || []);
  const [videoList, setVideoList] = useState(stepFour.videoList || []);
  const [imgPreview, setImgPreview] = useState([]);
  const [videoPreview, setVideoPreview] = useState([]);

  const addImage = (e) => {
    console.log(e.target.files);
    setImageList([...e.target.files]);
  };
  const addVideo = (e) => {
    console.log(e.target.files);
    setVideoList([...e.target.files]);
  };

  const removeImageItem = (list, index) => {
    if (index > -1) {
      let filteredList = list.filter((x, i) => i !== index);

      setImageList([...filteredList]);

      const d = {
        images: filteredList,
        videos: videoList,
      };

      dispatch(addStepFour(d));
    }
  };
  const removeItem = (list, index, setState) => {
    alert("remove item click");
    if (index > -1) {
      list.splice(index, 1);

      setState([...list]);
    }
  };

  useEffect(() => {
    // if (imgList.length < 1 ) return ;
    const newImgUrl = [];
    // imgList.forEach((img) => console.log(img)); //newImgUrl.push(URL.createObjectURL(img))
    imgList.forEach((img) => newImgUrl.push(URL.createObjectURL(img))); //
    setImgPreview(newImgUrl);
    // if (videoList.length < 1 ) return ;
    const newVideoUrl = [];
    videoList.forEach((video) => newVideoUrl.push(URL.createObjectURL(video)));
    setVideoPreview(newVideoUrl);

    
  }, [imgList, videoList]);

  useEffect(() => {
    if (imgList.length !== 0) {
      const d = {
        images: imgList,
        videos: videoList,
      };
      console.log("d", d);
      dispatch(addStepFour(d));
    }
  }, [dispatch, imgList, videoList]);

  return (
    <Box component="form" noValidate autoComplete="off">
      <div className="row">
        <div className="col-6">
          <div className="image__upload-container ">
            <label htmlFor="imageUpload">
              <Input
                onChange={addImage}
                multiple
                accept="image/*"
                id="imageUpload"
                type="file"
              />
              <IconButton
                style={{ width: "100%" }}
                size="large"
                color="warning"
                aria-label="upload picture"
                component="span"
              >
                <PhotoCamera style={{ fontSize: "3rem" }} />
              </IconButton>
            </label>

            <Box className="image-gallery col-12">
              {imgPreview.length === 0 && (
                <div className="icon bx bx-photo-album">
                  <p>Photo Upload</p>
                </div>
              )}
              {imgPreview.map((imgSrc, i) => {
                return (
                  <ImageListItem key={i} sx={{ margin: 2 }}>
                    <img
                      className="image-gallery-img"
                      src={`${imgSrc}`}
                      alt={"title"}
                      loading="lazy"
                    />
                    <ImageListItemBar
                      actionIcon={
                        <IconButton
                          onClick={() => removeImageItem(imgList, i)}
                          sx={{ color: "red" }}
                          aria-label={`info about ${"title"}`}
                        >
                          <InfoIcon />
                        </IconButton>
                      }
                    />
                  </ImageListItem>
                );
              })}
            </Box>
          </div>
        </div>
        <div className="col-6">
          <div className="image__upload-container ">
            <label htmlFor="videoUpload">
              <Input onChange={addVideo} id="videoUpload" type="file" />
              <IconButton
                size="large"
                color="warning"
                aria-label="upload Video"
                component="span"
              >
                <VideoCall style={{ fontSize: "3rem" }} />
              </IconButton>
            </label>
            <Box className="image-gallery col-12">
              {videoPreview.length === 0 && (
                <div className="icon bx bx-video-recording">
                  <p>Video Upload</p>
                </div>
              )}
              {videoPreview.map((videoSrc, i) => {
                return (
                  <ImageListItem key={i} sx={{ margin: 2 }}>
                    <video
                      style={{ width: "100%" }}
                      controls
                      autoPlay
                      loop
                      muted
                    >
                      <source src={videoSrc} type="video/mp4"></source>
                    </video>
                    <ImageListItemBar
                      actionIcon={
                        <IconButton
                          sx={{ color: "red" }}
                          aria-label={`info about ${"title"}`}
                          onClick={() =>
                            removeItem(videoPreview, i, setVideoPreview)
                          }
                        >
                          <InfoIcon />
                        </IconButton>
                      }
                    />
                  </ImageListItem>
                );
              })}
            </Box>
          </div>
        </div>

       Image List :  {
          JSON.stringify(imgList)
        }

       Video List :  {
          JSON.stringify(videoList)
        }
        <br></br>
        <br></br>
       Image List URL :  {
          JSON.stringify(stepFour.imagesUrl)
        }

       {/* Video List  URL:  {
          JSON.stringify(videoList)
        } */}
      </div>
    </Box>
  );
};

export default ProductStepOne;
